import React, { useState } from 'react';
import { TextField, Button, Container, Typography, ThemeProvider, createTheme, CssBaseline, Paper } from '@mui/material';
import YouTubeIcon from '@mui/icons-material/YouTube';
import SentimentVerySatisfiedIcon from '@mui/icons-material/SentimentVerySatisfied';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import SentimentNeutralIcon from '@mui/icons-material/SentimentNeutral';
import CircularProgress from '@mui/material/CircularProgress';
import { red } from '@mui/material/colors';

function App() {
  const [videoId, setVideoId] = useState('');
  const [sentimentData, setSentimentData] = useState('');

  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);  // start the loading

    const formData = new FormData();
    formData.append('video_id', videoId);

    try {
      const response = await fetch('https://kafka-yt-backend-59dc2f537aea.herokuapp.com/sentimenter', {
        method: 'POST',
        body: formData,
      });
      const data = await response.json();
      setSentimentData(data.result);
    } catch (error) {
      console.error('There was an error sending the request', error);
    } finally {
      setIsLoading(false);  // stop the loading
    }
  };

  const theme = createTheme({
    palette: {
      primary: red,
      background: {
        default: red[500],
        paper: '#ffffff',
      },
    },
    typography: {
      fontWeightBold: 700,
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container component="main" maxWidth="xs">
        <Paper elevation={3} style={{ padding: '20px', borderRadius: '15px', marginTop: '50px' }}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <YouTubeIcon style={{ fontSize: 80, margin: '20px 0', color: red[500] }} />
            <Typography variant="h3" gutterBottom style={{ fontWeight: 'bold' }}>
              YouTube
            </Typography>
            <Typography variant="h4" gutterBottom style={{ fontWeight: 'bold' }}>
              Sentiment Analysis
            </Typography>
            <form onSubmit={handleSubmit} noValidate>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="video_id"
                label="Video ID"
                name="video_id"
                autoFocus
                value={videoId}
                onChange={e => setVideoId(e.target.value)}
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                style={{ margin: '20px 0' }}
              >
                Analyze
              </Button>
            </form>
            {sentimentData && (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
                <SentimentVerySatisfiedIcon fontSize="large" color="primary" />
                <SentimentNeutralIcon fontSize="large" color="action" />
                <SentimentDissatisfiedIcon fontSize="large" color="error" />
                <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                  {sentimentData}
                </Typography>
              </div>
            )}
          </div>
          {isLoading && <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
            <CircularProgress />
          </div>}
          
        </Paper>
        
      </Container>
    </ThemeProvider>
  );
}

export default App;
